import axios from 'axios';
import onDownloadProgress from './requestHelpers';
import {
  backendRequestBaseParams as baseParams,
  backendUrl,
  inventoryUrl,
} from '../constants/general';

export const addAgency = data =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/agency/create`,
    data,
  });

export const addAgent = data =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/agent/create`,
    data,
  });

export const addEmployee = (employee, contracts) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/studio-employee/create`,
    data: {
      employee,
      contracts,
    }
  });

export const addNote = (data) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/note/`,
    data,
  });

export const addOrigin = (data) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/v1/origins/`,
    data,
  });

export const addLocation = (params) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/v1/locations/`,
    data: params,
  });

export const addSpecialProject = (projectName, notes, startDate, endDate) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/specialProjects/addSpecialProject`,
    data: { projectName, notes, startDate, endDate },
  });

export const deleteAgency = (data) =>
  axios.request({
    ...baseParams,
    method: 'DELETE',
    url: `${backendUrl}/agency/delete`,
    data,
  });

export const deleteAgent = (data) =>
  axios.request({
    ...baseParams,
    method: 'DELETE',
    url: `${backendUrl}/agent/delete`,
    data,
  });

export const deleteContracts = (contracts) =>
  axios.request({
    ...baseParams,
    method: 'DELETE',
    url: `${backendUrl}/contract/delete`,
    data: {
      contracts,
    },
  });

export const deleteNote = (data) =>
  axios.request({
    ...baseParams,
    method: 'DELETE',
    url: `${backendUrl}/note/`,
    data
  });

export const deleteOrigin = (originId) =>
  axios.request({
    ...baseParams,
    method: 'DELETE',
    url: `${backendUrl}/v1/origins/${originId}`,
  });

export const deleteSpecialProject = (specialProjectId) =>
  axios.request({
    ...baseParams,
    method: 'DELETE',
    url: `${backendUrl}/specialProjects/deleteSpecialProject`,
    data: { specialProjectId },
  });

export const fastTrack = (bookings) =>
  axios.request({
    ...baseParams,
    method: 'PATCH',
    url: `${backendUrl}/booking/fastTrack`,
    data: {
      bookings,
    }
  });

export const fetchAgencies = () =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/agency/find-all-names-and-ids`
  });

export const fetchAgents = () =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/agent/find-all`
  });

export const fetchAvailabilities = (date) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/availability/dateSchedule/`,
    params: {
      date,
    },
});

export const fetchAvailabilityByPosition = (positionId, startDate, endDate) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/availability/availabilityByPosition`,
    params: {
      positionId,
      startDate,
      endDate,
    },
  });

export const fetchBookingScheduleData = (startDate, endDate) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/booking/scheduleView/`,
    params: {
      startDate,
      endDate,
    },
  });

export const fetchCallSheetData = (date) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/callsheet/`,
    params: {
      date,
    },
  });

export const fetchContracts = (employeeId) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/contract/find-all-by-employee-id`,
    params: {
      id: employeeId,
    },
  });

export const fetchTtlCsv = (setProgress, fileUrl, filename, contentLength) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: '/reporting/timeToListCsvFile',
    params: { fileUrl },
    onDownloadProgress: (progressEvent) => onDownloadProgress(progressEvent, setProgress, filename, contentLength),
  });

export const fetchTtlCsvEntry = () =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: '/reporting/timeToListCsv',
  });

export const fetchTtlCsvStatusAll = () =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: '/reporting/timeToListCsvStatusAll'
  });

export const fetchTtlCsvStatus = (exportId) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `/reporting/timeToListCsvStatus/${exportId}`
  });

export const fetchEcommDailyAssignmentData = (date) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/ecomm/fetch`,
    params: { date },
  });

export const fetchFormattedEmployeeSchedule = (studioEmployeeId, firstOfMonth, weeksToFetch) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/availability/${studioEmployeeId}/formatted-schedule/${firstOfMonth}/${weeksToFetch}`,
  });

export const fetchLocations = (params) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/v1/locations/`,
    params,
  });

export const fetchLocationTypes = () =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/v1/locations/locationTypes/`,
  });

export const fetchMe = (email, isAuthEnabled) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: '/me',
    ...(!isAuthEnabled()) && {
      params: {
        email
      }
    }
  });

export const fetchNotes = (employeeId) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/note/`,
    params: {
      employeeId,
    },
  });

export const fetchOrigins = () =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/v1/origins/`
  });

export const fetchSpecialProjects = () =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/specialProjects/fetchAll`
  });

export const fetchStudioEmployee = (id) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/studio-employee/find`,
    params: {
      id,
    },
  });

export const fetchStudioEmployeeBasic = () =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/studio-employee/basic`,
  });

export const fetchUnbookedFreelancers = (startDate, endDate) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/booking/scheduleView/unbooked-freelancers`,
    params: {
      startDate,
      endDate,
    },
  });

export const fetchPositions = () =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/position/names-and-ids`
  });

export const fetchPositionsBasic = () =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/position/basic`,
  });

export const fetchPositionsAll = () =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/position/`,
  });

export const generateConfirmation = (selectedDate, selectedEmployeeIds) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/booking/generateConfirmation`,
    data: {
      selectedDate,
      selectedEmployeeIds,
    },
  });

export const getClosetProducts = (params) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${inventoryUrl}/products/`,
    params,
  });

export const getSuggestedEmployees = (params) =>
  axios.request({
    ...baseParams,
    method: 'GET',
    url: `${backendUrl}/suggester/suggested`,
    params,
  });

export const hydrateCart = (data) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${inventoryUrl}/cart/hydrate`,
    data,
  });

export const mergeSkus = (data) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/v1/carryover/bulk-carryover`,
    data,
  });

export const releaseBookings = (bookingIds) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/booking/release`,
    data: {
      bookingIds,
    },
  });

export const removeBookings = (bookingsToRemove) =>
  axios.request({
    ...baseParams,
    method: 'DELETE',
    url: `${backendUrl}/booking/remove`,
    data: {
      bookingsToRemove,
    },
  });

export const requestCartItems = (data) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${inventoryUrl}/cart/request`,
    data,
  });

export const saveBookings = (date, bookings) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/booking/book`,
    data: {
      date,
      bookings,
    },
  });

export const saveContracts = (contracts, employeeId) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/contract/save/`,
    data: {
      contracts,
      id: employeeId,
    },
  });

export const saveEmployeeAvailability = (studioEmployeeId, payload) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/availability/${studioEmployeeId}/schedule`,
    data: payload,
  });

export const saveOneEcommDailyAssignment = (locationType, data) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/ecomm/${locationType}/save-one`,
    data,
  });

export const sendAvailabilityEmail = (data) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/availability/sendAvailabilityEmail`,
    data,
  });

export const sendCallSheets = (emailData) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/email/send-call-sheets`,
    data: {
      emailData,
    }
  });

export const updateAgency = (data) =>
  axios.request({
    ...baseParams,
    method: 'PUT',
    url: `${backendUrl}/agency/update`,
    data,
  });

export const updateAgent = (data) =>
  axios.request({
    ...baseParams,
    method: 'PUT',
    url: `${backendUrl}/agent/update`,
    data,
  });

export const updateAttribute = (id, positionName, editedAttribute, oldAttributes) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/attribute_control`,
    data: { id, positionName, editedAttribute, oldAttributes }
  });

export const updateEmployeeProfile = (data) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/studio-employee/editProfile/`,
    data,
  });

export const updateLocations = (data) =>
  axios.request({
    ...baseParams,
    method: 'PUT',
    url: `${backendUrl}/v1/locations/`,
    data,
  });

export const updateModelMeasurement = (data) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/modelMeasurement/editModelMeasurement/`,
    data,
  });

export const updateNote = (data) =>
  axios.request({
    ...baseParams,
    method: 'PUT',
    url: `${backendUrl}/note/update`,
    data,
  });

export const updateOrigin = (selectedOriginId, data) =>
  axios.request({
    ...baseParams,
    method: 'PATCH',
    url: `${backendUrl}/v1/origins/${selectedOriginId}`,
    data,
  });

export const updatePositionAttributes = (data) =>
  axios.request({
    ...baseParams,
    method: 'POST',
    url: `${backendUrl}/studio-employee/editPositionAttributes/`,
    data,
  });

export const updateProfileImage = (data, employeeId) =>
  axios.request({
    ...baseParams,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    url: `${backendUrl}/studio-employee/${employeeId}/update-profile-image`,
    data,
  });

export const updateSpecialProject = (specialProjectId, specialProjectName, notes, startDate, endDate) =>
  axios.request({
    ...baseParams,
    method: 'PUT',
    url: `${backendUrl}/specialProjects/editSpecialProject`,
    data: { specialProjectId, specialProjectName, notes, startDate, endDate },
  })
